// @ts-strict-ignore
import type { I18nT } from "@lib/dashboardI18n";
import type { AspectRatio, AspectRatioOption } from "@lib/mediaLibrary";

import { getAspectRatioInfo } from "./getAspectRatioInfo";
import { getCustomAspectRatioOptions } from "./getCustomAspectRatioOptions";

/**
 * Used to generate a list of AspectRatio options
 */
export const getAspectRatioOptions = (
  t: I18nT<"media-library">,
  ratios: AspectRatio[],
  tolerance?: number
): AspectRatioOption[] => {
  const result = [];

  ratios.forEach((ratio) => {
    result.push(getAspectRatioInfo(t, ratio, tolerance));
  });

  return getCustomAspectRatioOptions(result);
};
